import { cursorPaginationFieldPolicy } from '../../../../utils/policies';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Share: {
    fields: {
      /**
       * ShareReviewer has no `id` of its own, so cursor pages are deduped by the
       * reviewer's normalized AccountUser reference instead of the default node id.
       */
      reviewers: cursorPaginationFieldPolicy(
        ['filter', ['searchTerm']],
        false,
        (node) => node?.accountUser?.__ref ?? node?.accountUser?.id
      ),
    },
  },
};
